import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import './styles.scss';
import Dropdown, {
  DropdownOption,
} from '@axa-asia/emma-stylesheet/lib/components/Dropdown/Dropdown';
import {
  resolvePublicAssets,
  resolveLocalizedText,
  getValidToken,
  isApp,
} from '../../../../utils';
import { connect } from 'react-redux';
import {
  getOffersSmartHomeConfig,
  getOffersCardsByFeatureIdConfig,
} from '../../selectors/offersSelector';
import { LocalizedText } from '../../../../types/LocalizedTextTypes';
import { t } from '../../../../locales';
import uuidv4 from 'uuid/v4';
import { submitOffersLeadForm } from '../../actions/offersFormAction';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@axa-asia/emma-stylesheet/lib/components/Modal';
import { getToken } from '../../../../selectors/authSelectors';
import { select } from '../../../../stores';
import { pushTitle } from '../../../../actions/historyActions';
import {
  getGaPagePath,
  handleGaError,
} from '../../../../utils/generalGaEventAnalytics';
import { trackSubmitLeadForm } from '../../../../utils/firebaseAnalyticsEvents';
export interface OffersSmartHomeContainerProps {
  match: {
    params: {
      sectionId: string;
      featureId: string;
    };
  };
  lang: string;
  title: string;
  desc: string;
  subDesc: string;
  bannerImg: string;
  bannerImg1: string;
  remarks: string;
  offersSmartHomeFormConfig: any;
  submitOffersLeadForm: (value: any) => void;
  source: string;
  onPushTitle: (title: string) => void;
  primaryCampaignSource: string;
}

interface OffersSmartHomeContainerState {
  isShowOptionList: boolean;
  ContactTimeList: Array<object>;
  isShowMobileOptionList: boolean;
  mobileValue: string;
  optionMobileList: Array<object>;
  // Full name
  nameState: string;
  isShowNameError: boolean;
  isShowNameCorrect: boolean;
  // Email
  emailState: string;
  isShowEmailError: boolean;
  isShowEmailCorrect: boolean;
  // mobile
  mobileNoState: string;
  isShowMobileError: boolean;
  isShowMobileCorrect: boolean;
  // contact time
  value: string;
  isShowContactTimeError: boolean;
  isShowContactTimeCorrect: boolean;
  // show button
  isEnableSubmitButton: boolean;
  // Policy modal
  isShowModal: boolean;
}

export class OffersSmartHomeContainer extends Component<
  OffersSmartHomeContainerProps,
  OffersSmartHomeContainerState
> {
  constructor(props: any = {}) {
    super(props);
    this.state = {
      // Full name
      nameState: '',
      isShowNameError: false,
      isShowNameCorrect: false,
      // Email
      emailState: '',
      isShowEmailError: false,
      isShowEmailCorrect: false,
      isShowOptionList: false,
      value: '',
      ContactTimeList: [
        {
          optionVal: `${t(
            'MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_ANY_TIME',
          )}`,
          optionTitle: `${t(
            'MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_ANY_TIME',
          )}`,
        },
        {
          optionVal: `${t(
            'MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_IN_THE_MORNING',
          )}`,
          optionTitle: `${t(
            'MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_IN_THE_MORNING',
          )}`,
        },
        {
          optionVal: `${t(
            'MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_LUNCH_TIME',
          )}`,
          optionTitle: `${t(
            'MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_LUNCH_TIME',
          )}`,
        },
        {
          optionVal: `${t(
            'MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_IN_THE_AFTERNOON',
          )}`,
          optionTitle: `${t(
            'MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_IN_THE_AFTERNOON',
          )}`,
        },
      ],
      isShowMobileOptionList: false,
      mobileValue: '852',
      optionMobileList: [
        {
          optionVal: '852',
          optionTitle: '852',
        },
        {
          optionVal: '853',
          optionTitle: '853',
        },
        {
          optionVal: '86',
          optionTitle: '86',
        },
      ],
      mobileNoState: '',
      isShowMobileError: false,
      isShowMobileCorrect: false,
      isShowContactTimeError: false,
      isShowContactTimeCorrect: false,
      isEnableSubmitButton: true,
      isShowModal: false,
    };
    this.setOpenOption = this.setOpenOption.bind(this);
    this.setOpenMoblieOption = this.setOpenMoblieOption.bind(this);
    this.onBlurInputName = this.onBlurInputName.bind(this);
    this.onBlurInputEmail = this.onBlurInputEmail.bind(this);
    this.onBlurInputMobile = this.onBlurInputMobile.bind(this);
    this.validationForm = this.validationForm.bind(this);
    this.onSubmitOffersLeadForm = this.onSubmitOffersLeadForm.bind(this);
    this.onShowModal = this.onShowModal.bind(this);
    this.onHideModal = this.onHideModal.bind(this);
    this.onBlurOptions = this.onBlurOptions.bind(this);
  }

  // Full name
  onBlurInputName(e: any) {
    let value = e.target.value;
    value = value.replace(/[^\u4E00-\u9FA5a-zA-Z\s]/g, '');
    if (value) {
      this.setState({
        isShowNameError: false,
        isShowNameCorrect: true,
        nameState: value,
      });
    } else {
      this.setState({
        isShowNameError: true,
        isShowNameCorrect: false,
        nameState: value,
      });
    }
  }
  // Email
  onBlurInputEmail(e: any) {
    const value = e.target.value.trim();
    this.setState({
      emailState: value,
    });
    if (!value) {
      this.setState({
        isShowEmailError: true,
        isShowEmailCorrect: false,
      });
    } else if (!/^[^\s@]+@[^\s@\\.]+\.[^\s@]{2,}$/.test(value)) {
      this.setState({
        isShowEmailError: true,
        isShowEmailCorrect: false,
      });
    } else {
      this.setState({
        isShowEmailError: false,
        isShowEmailCorrect: true,
      });
    }
  }
  // mobile
  isValidMobileNumber(countryCode: string, mobileNo: string) {
    const mobileLen = mobileNo.length;
    if (RegExp(/[^0-9]/).test(mobileNo)) return false;
    if (countryCode === '86') {
      return mobileLen === 11;
    } else if (countryCode === '852' || countryCode === '853') {
      return mobileLen === 8;
    }
    return false;
  }
  onBlurInputMobile(e: any) {
    let value = e.target.value.trim();
    value = value.length > 8 ? value.slice(0, value.length - 1) : value;
    if (value && this.isValidMobileNumber(this.state.mobileValue, value)) {
      this.setState(
        {
          isShowMobileError: false,
          isShowMobileCorrect: true,
        },
        () => {},
      );
    } else {
      this.setState(
        {
          isShowMobileError: true,
          isShowMobileCorrect: false,
        },
        () => {},
      );
    }
    this.setState({ mobileNoState: value });
  }

  setOpenOption(val: boolean) {
    return this.setState({
      isShowOptionList: val,
    });
  }

  chooseOption(val: string) {
    return this.setState({
      value: val,
      isShowContactTimeError: false,
      isShowContactTimeCorrect: true,
    });
  }

  setOpenMoblieOption(val: boolean) {
    return this.setState({
      isShowMobileOptionList: val,
    });
  }

  chooseMoblieOption(val: string) {
    return this.setState({
      mobileValue: val,
    });
  }

  // policy modal
  onShowModal() {
    this.setState({
      isShowModal: true,
    });
  }
  onHideModal() {
    this.setState({
      isShowModal: false,
    });
  }

  validationForm() {
    const {
      isShowNameCorrect,
      isShowEmailCorrect,
      isShowMobileCorrect,
      isShowContactTimeCorrect,
    } = this.state;
    const infoErrors =
      isShowNameCorrect &&
      isShowEmailCorrect &&
      isShowMobileCorrect &&
      isShowContactTimeCorrect
        ? false
        : true;
    return infoErrors;
  }

  componentDidMount() {
    const { onPushTitle } = this.props;
    onPushTitle('');
  }

  onSubmitOffersLeadForm() {
    if (!this.validationForm()) {
      const transactionId = uuidv4();
      const url = new URL(window.location.href);
      const gaClientId = url.searchParams.get(`clientId`) || '';
      const gaTrackId = url.searchParams.get(`axaId`) || '';
      const tcWindow: any = window;
      const token = select(getToken);
      const aToken = getValidToken(token);
      const screenName = getGaPagePath();
      const featureId =
        this.props.match.params && this.props.match.params.featureId;
      const leadSource =
        featureId === 'smarthome'
          ? 'home-insurance'
          : featureId === 'smartdrive'
          ? 'motor-insurance'
          : featureId;
      const leadProduct = 'offers';
      try {
        // GA3
        tcWindow.dataLayer.push({
          event: 'SubmitMyPolicyLeadForm',
          screenName: screenName,
          leadType: 'giilead',
          leadProduct: leadProduct,
          leadSource: leadSource,
          leadId: transactionId,
          userId: aToken,
        });

        // GA4
        trackSubmitLeadForm(
          screenName,
          'giilead',
          leadProduct,
          leadSource,
          transactionId,
        );

        // HKEMMA-100917 - GA3 Decommission - Remove GA3
        // if (!isApp()) {
        //   tcWindow.tC.event.SubmitMyPolicyLeadForm(tcWindow, {
        //     screenName: screenName,
        //     leadType: 'giilead',
        //     leadProduct: leadProduct,
        //     leadSource: leadSource,
        //     leadId: transactionId,
        //     AXAID: aToken,
        //   });
        // }
      } catch (e) {
        handleGaError(e);
      }
      const { nameState, emailState, mobileValue, mobileNoState, value } =
        this.state;
      const { source, primaryCampaignSource, title } = this.props;
      const submitValues = {
        campaign: `${leadProduct}-${leadSource}`,
        isipro: true,
        iscustomer: '1',
        leadAutoConvert: '1',
        language: 'en',
        name: nameState,
        telephone: `${mobileNoState}`,
        email: emailState,
        prefertime: value,
        prefix: mobileValue,
        transactionid: transactionId, // note that transactionid field name is lowercase
        primaryCampaignSource: primaryCampaignSource,
        leadSource: 'iLife',
        leadChannel: 'HK_Emma',
        leadLevel: 'Gold',
        GACLIENTID: gaClientId,
        GATRACKID: gaTrackId,
        axaId: aToken,
        title: title,
        price: {},
      };
      this.setState({
        isEnableSubmitButton: false,
      });
      this.props.submitOffersLeadForm(submitValues);
    }
  }

  onBlurOptions(val: string) {
    val === '' &&
      this.setState({
        isShowContactTimeError: true,
        isShowContactTimeCorrect: false,
      });
  }

  render() {
    const {
      value,
      ContactTimeList,
      isShowOptionList,
      mobileValue,
      optionMobileList,
      isShowMobileOptionList,
      nameState,
      isShowNameError,
      isShowNameCorrect,
      emailState,
      isShowEmailError,
      isShowEmailCorrect,
      mobileNoState,
      isShowMobileError,
      isShowMobileCorrect,
      isEnableSubmitButton,
      isShowModal,
      isShowContactTimeError,
    } = this.state;
    const infoErrors = this.validationForm();
    const {
      title,
      desc,
      subDesc,
      bannerImg,
      bannerImg1,
      remarks,
      offersSmartHomeFormConfig,
    } = this.props;
    const {
      requiredField,
      name,
      email,
      mobile,
      contactTime,
      attachmentDesc,
      submitRemarkDesc,
      ctaButton,
    } = offersSmartHomeFormConfig;
    const banner = resolvePublicAssets(bannerImg);
    const banner1 = resolvePublicAssets(bannerImg1);
    const documentBlue = resolvePublicAssets(
      `/assets/images/offers/document-blue.png`,
    );
    const giftImage = resolvePublicAssets(`/assets/images/offers/gifttag.png`);
    return (
      <div className="offers-smart-home-container emma-stylesheet-grid-system">
        <div className="offers-smart-home-container-title">
          <span>{title}</span>
        </div>
        <div className="offers-smart-home-container-banner content-align-right">
          <img
            src={banner1}
            className="offers-smart-home-container-banner-img1"
          ></img>
          <div className="offers-smart-home-container-banner-desc">
            <div>
              {desc}
              <span className="offers-smart-home-container-banner-desc-span">
                {subDesc}
              </span>
            </div>
          </div>
          <div className="offers-smart-home-container-banner-img">
            <img src={banner}></img>
          </div>
        </div>
        <div className="offers-smart-home-container-remark">{remarks}</div>
        <div className="row">
          <div className="offers-smart-home-container-form col-12 col-lg-6">
            <div className="row">
              <div className="col-12">
                <div className="emma-stylesheet-label offers-smart-home-container-form-required">
                  <label
                    className="emma-stylesheet-label__text"
                    htmlFor="text1"
                  >
                    {requiredField}
                  </label>
                </div>
              </div>
            </div>

            {/* full name */}
            <div className="row">
              <div className="col-12">
                <div className="emma-stylesheet-label">
                  <label
                    className="emma-stylesheet-label__text"
                    htmlFor="text1"
                  >
                    {name.label}
                  </label>
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className={`emma-stylesheet-input col-12 ${
                  isShowNameError && name.errorMessage
                    ? 'emma-stylesheet-input-error'
                    : isShowNameCorrect
                    ? 'emma-stylesheet-input-success'
                    : ''
                }`}
              >
                <input
                  className={`emma-stylesheet-input-field col-12 ${
                    isShowNameError && name.errorMessage
                      ? 'emma-stylesheet-input-error-field'
                      : 'emma-stylesheet-input-success-field'
                  }`}
                  defaultValue={nameState}
                  value={nameState}
                  id={name.label}
                  placeholder={name.placeholder}
                  type="text"
                  maxLength={100}
                  onChange={this.onBlurInputName}
                  onBlur={this.onBlurInputName}
                />
              </div>
            </div>
            {isShowNameError && name.errorMessage && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {name.errorMessage}
                </div>
              </div>
            )}
            {/* email */}
            <div className="row">
              <div className="col-12">
                <div className="emma-stylesheet-label">
                  <label
                    className="emma-stylesheet-label__text"
                    htmlFor="text1"
                  >
                    {email.label}
                  </label>
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className={`emma-stylesheet-input col-12 ${
                  isShowEmailError && email.errorMessage
                    ? 'emma-stylesheet-input-error'
                    : isShowEmailCorrect
                    ? 'emma-stylesheet-input-success'
                    : ''
                }`}
              >
                <input
                  className={`emma-stylesheet-input-field col-12 ${
                    isShowEmailError && email.errorMessage
                      ? 'emma-stylesheet-input-error-field'
                      : isShowEmailCorrect
                      ? 'emma-stylesheet-input-success-field'
                      : ''
                  }`}
                  defaultValue={emailState}
                  id={email.label}
                  placeholder={email.placeholder}
                  type="text"
                  onChange={this.onBlurInputEmail}
                  onBlur={this.onBlurInputEmail}
                />
              </div>
            </div>
            {isShowEmailError && email.errorMessage && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {email.errorMessage}
                </div>
              </div>
            )}
            {/* Mobile no.  */}
            <div className="row">
              <div className="col-12">
                <div className="emma-stylesheet-label">
                  <label
                    className="emma-stylesheet-label__text"
                    htmlFor="text1"
                  >
                    {mobile.label}
                  </label>
                </div>
              </div>
            </div>
            <div className="row content-align-right">
              <div className="emma-stylesheet-input offers-smart-home-container-form-mobile-dropdown">
                <input
                  className="emma-stylesheet-input-field col-12"
                  defaultValue={mobileValue}
                  value={mobileValue}
                  type="text"
                  disabled
                />
                {/* <Dropdown
                  dropDownClassName="col-12"
                  optionList={optionMobileList}
                  isShowOptionList={isShowMobileOptionList}
                  setOption={this.setOpenMoblieOption}
                  value={mobileValue}
                  onClickAction={(val: string) => {
                    this.chooseMoblieOption(val);
                  }}
                /> */}
              </div>
              <div
                className={`emma-stylesheet-input offers-smart-home-container-form-mobile-input ${
                  isShowMobileError && mobile.errorMessage
                    ? 'emma-stylesheet-input-error'
                    : isShowMobileCorrect
                    ? 'emma-stylesheet-input-success'
                    : ''
                }`}
              >
                <input
                  className={`emma-stylesheet-input-field col-12 ${
                    isShowMobileError && mobile.errorMessage
                      ? 'emma-stylesheet-input-error-field'
                      : 'emma-stylesheet-input-success-field'
                  }`}
                  defaultValue={mobileNoState}
                  value={mobileNoState}
                  id={mobile.label}
                  placeholder={mobile.placeholder}
                  type="number"
                  onChange={this.onBlurInputMobile}
                  onBlur={this.onBlurInputMobile}
                />
              </div>
            </div>
            {isShowMobileError && mobile.errorMessage && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {mobile.errorMessage}
                </div>
              </div>
            )}
            {/* dropdown */}
            <div className="row">
              <div className="col-12">
                <div className="emma-stylesheet-label">
                  <label
                    className="emma-stylesheet-label__text"
                    htmlFor="text1"
                  >
                    {contactTime.label}
                  </label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="emma-stylesheet-input col-12">
                <Dropdown
                  dropDownClassName="col-12"
                  optionList={ContactTimeList as DropdownOption[]}
                  isShowOptionList={isShowOptionList}
                  setOption={this.setOpenOption}
                  value={value}
                  title={contactTime.placeholder}
                  onClickAction={(val: string) => {
                    this.chooseOption(val);
                  }}
                  onBlurOptions={this.onBlurOptions}
                />
              </div>
            </div>
            {isShowContactTimeError && contactTime.errorMessage && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {contactTime.errorMessage}
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-12 offers-smart-home-container-form-dropdown-remark">
                {contactTime.remark}
              </div>
            </div>
            {/* attachment */}
            {/* <div className="row">
              <div className="col-12 offers-smart-home-container-form-attachment">
                <div className="col-12 offers-smart-home-container-form-attachment-item content-align-level">
                  <img className="offers-smart-home-container-form-attachment-item-icon" src={documentBlue}></img>
                  <div className="offers-smart-home-container-form-attachment-item-desc">
                    {attachmentDesc}
                  </div>
                </div>
              </div>
            </div> */}
            {/* submit remark */}
            <div className="row">
              <div
                className="col-12 offers-smart-home-container-form-submit-remark"
                dangerouslySetInnerHTML={{
                  __html: memoSanitize(submitRemarkDesc),
                }}
              ></div>
            </div>
            {/* submit button */}
            <div className="row">
              <div className="col-12 offers-smart-home-container-form-submit-button content-align">
                <button
                  className={`emma-stylesheet-input ${
                    infoErrors || !isEnableSubmitButton
                      ? 'emma-stylesheet-primary-secondary-default-disabled-button'
                      : 'emma-stylesheet-primary-default-button'
                  }`}
                  disabled={infoErrors || !isEnableSubmitButton ? true : false}
                  type="submit"
                  onClick={this.onSubmitOffersLeadForm}
                  data-enable-ga={!(infoErrors || !isEnableSubmitButton)}
                  data-ga-type="button"
                >
                  {ctaButton}
                </button>
              </div>
            </div>
          </div>
        </div>
        <Modal show={isShowModal} onHide={this.onHideModal}>
          <ModalHeader>
            <span>{t('OFFERS_FORM_POLICY_MODAL_HEADER')}</span>
          </ModalHeader>
          <ModalBody>
            <span
              dangerouslySetInnerHTML={{
                __html: memoSanitize(t('OFFERS_FORM_POLICY_MODAL_DETAILS')),
              }}
            ></span>
          </ModalBody>
          <ModalFooter>
            <div className="modal-footer-btn-align__right">
              <button
                className="emma-stylesheet-primary-default-button"
                onClick={this.onHideModal}
                data-enable-ga
                data-ga-type="button"
              >
                {t('CLOSE')}
              </button>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
  static mapStateToProps(state: any, ownProps: any) {
    const { sectionId, featureId } = ownProps.match.params;
    const offersSmartHomeConfig = getOffersSmartHomeConfig(state);
    const offersCardsConfig = getOffersCardsByFeatureIdConfig(
      state,
      sectionId,
      featureId,
    );
    const offersSmartHomeFormConfig =
      offersSmartHomeConfig && offersSmartHomeConfig.form
        ? offersSmartHomeConfig.form
        : {};
    return {
      title:
        offersCardsConfig &&
        offersCardsConfig.form &&
        offersCardsConfig.form.header
          ? resolveLocalizedText(offersCardsConfig.form.header)
          : '',
      source:
        offersCardsConfig &&
        offersCardsConfig.form &&
        offersCardsConfig.form.source
          ? offersCardsConfig.form.source
          : '',
      desc:
        offersSmartHomeConfig && offersSmartHomeConfig.desc
          ? resolveLocalizedText(offersSmartHomeConfig.desc)
          : '',
      subDesc:
        offersSmartHomeConfig && offersSmartHomeConfig.subDesc
          ? resolveLocalizedText(offersSmartHomeConfig.subDesc)
          : '',
      bannerImg:
        offersSmartHomeConfig && offersSmartHomeConfig.bannerImg
          ? offersSmartHomeConfig.bannerImg
          : '',
      bannerImg1:
        offersSmartHomeConfig && offersSmartHomeConfig.bannerImg1
          ? offersSmartHomeConfig.bannerImg1
          : '',
      remarks:
        offersSmartHomeConfig && offersSmartHomeConfig.remarks
          ? resolveLocalizedText(offersSmartHomeConfig.remarks)
          : '',
      primaryCampaignSource:
        offersSmartHomeConfig && offersSmartHomeConfig.primaryCampaignSource
          ? offersSmartHomeConfig.primaryCampaignSource
          : '',
      offersSmartHomeFormConfig: {
        requiredField:
          offersSmartHomeFormConfig && offersSmartHomeFormConfig.requiredField
            ? resolveLocalizedText(offersSmartHomeFormConfig.requiredField)
            : '',
        name: {
          label:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.name &&
            offersSmartHomeFormConfig.name.label
              ? resolveLocalizedText(offersSmartHomeFormConfig.name.label)
              : '',
          placeholder:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.name &&
            offersSmartHomeFormConfig.name.placeholder
              ? resolveLocalizedText(offersSmartHomeFormConfig.name.placeholder)
              : '',
          errorMessage:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.name &&
            offersSmartHomeFormConfig.name.errorMessage
              ? resolveLocalizedText(
                  offersSmartHomeFormConfig.name.errorMessage,
                )
              : '',
        },

        email: {
          label:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.email &&
            offersSmartHomeFormConfig.email.label
              ? resolveLocalizedText(offersSmartHomeFormConfig.email.label)
              : '',
          placeholder:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.email &&
            offersSmartHomeFormConfig.email.placeholder
              ? resolveLocalizedText(
                  offersSmartHomeFormConfig.email.placeholder,
                )
              : '',
          errorMessage:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.email &&
            offersSmartHomeFormConfig.email.errorMessage
              ? resolveLocalizedText(
                  offersSmartHomeFormConfig.email.errorMessage,
                )
              : '',
        },
        mobile: {
          label:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.mobile &&
            offersSmartHomeFormConfig.mobile.label
              ? resolveLocalizedText(offersSmartHomeFormConfig.mobile.label)
              : '',
          placeholder:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.mobile &&
            offersSmartHomeFormConfig.mobile.placeholder
              ? resolveLocalizedText(
                  offersSmartHomeFormConfig.mobile.placeholder,
                )
              : '',
          errorMessage:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.mobile &&
            offersSmartHomeFormConfig.mobile.errorMessage
              ? resolveLocalizedText(
                  offersSmartHomeFormConfig.mobile.errorMessage,
                )
              : '',
        },
        contactTime: {
          label:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.contactTime &&
            offersSmartHomeFormConfig.contactTime.label
              ? resolveLocalizedText(
                  offersSmartHomeFormConfig.contactTime.label,
                )
              : '',
          placeholder:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.contactTime &&
            offersSmartHomeFormConfig.contactTime.placeholder
              ? resolveLocalizedText(
                  offersSmartHomeFormConfig.contactTime.placeholder,
                )
              : '',
          errorMessage:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.contactTime &&
            offersSmartHomeFormConfig.contactTime.errorMessage
              ? resolveLocalizedText(
                  offersSmartHomeFormConfig.contactTime.errorMessage,
                )
              : '',
          remark:
            offersSmartHomeFormConfig &&
            offersSmartHomeFormConfig.contactTime &&
            offersSmartHomeFormConfig.contactTime.remark
              ? resolveLocalizedText(
                  offersSmartHomeFormConfig.contactTime.remark,
                )
              : '',
        },
        attachmentDesc:
          offersSmartHomeFormConfig && offersSmartHomeFormConfig.attachmentDesc
            ? resolveLocalizedText(offersSmartHomeFormConfig.attachmentDesc)
            : '',
        submitRemarkDesc:
          offersSmartHomeFormConfig &&
          offersSmartHomeFormConfig.submitRemarkDesc
            ? resolveLocalizedText(offersSmartHomeFormConfig.submitRemarkDesc)
            : '',
        ctaButton:
          offersSmartHomeFormConfig && offersSmartHomeFormConfig.ctaButton
            ? resolveLocalizedText(offersSmartHomeFormConfig.ctaButton)
            : '',
        offersStartHomeFormSubmitApi:
          offersSmartHomeFormConfig &&
          offersSmartHomeFormConfig.offersStartHomeFormSubmitApi
            ? offersSmartHomeFormConfig.offersStartHomeFormSubmitApi
            : '',
      },
    };
  }
  static mapDispatchToProps(dispatch: any) {
    return {
      submitOffersLeadForm: (value: any) => {
        dispatch(submitOffersLeadForm(value));
      },
      onPushTitle: (title: string) => dispatch(pushTitle(title)),
    };
  }
}

export default connect(
  OffersSmartHomeContainer.mapStateToProps,
  OffersSmartHomeContainer.mapDispatchToProps,
)(OffersSmartHomeContainer);
